import { render, staticRenderFns } from "./TenantPreferenceList.vue?vue&type=template&id=7f782715&"
import script from "./TenantPreferenceList.vue?vue&type=script&lang=ts&"
export * from "./TenantPreferenceList.vue?vue&type=script&lang=ts&"
import style0 from "./TenantPreferenceList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports